import React from 'react'
import { ProgramRequestOfferContentItem } from './Item'

type Props = {
  items: {
    label: string
    value: string
  }[]
}

export const ProgramRequestOfferContent = ({ items }: Props): JSX.Element => (
  <div className="flex flex-col">
    {items.map((item, i) => (
      <div key={i} className="first:mt-0 md:mt-[1.6vw]">
        <ProgramRequestOfferContentItem {...item} />
      </div>
    ))}
  </div>
)
